<template>
    <div class="content">
        <p class="title" v-if="isFirstCreate">{{value.title}}</p>
        <div ref="echart" class="echart"></div>
    </div>
</template>

<script>
import {mixinCreateEchart} from '../mixins/createEchart'
import echarts from 'echarts'

export default {
  name: 'barTickAlign',
  mixins: [mixinCreateEchart],
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    gridTop: {
      type: String || Number,
      default: 50
    }
  },
  data () {
    return {
      echart: null,
      option: {
        color: '#42C0E9',
        grid: {
          top: this.gridTop,
          left: 10,
          right: 10,
          bottom: '5%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          showContent: false
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            color: '#909399'
          },
          axisLine: {
            lineStyle: {color: '#909399'}
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          nameGap: 5,
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            color: '#909399',
            formatter: function (value, index) {
              if ((index % 3) === 0) {
                return value
              } else if (isNaN(index)) {
                return value
              } else {
                return ''
              }
            }
          },
          axisLine: {
            lineStyle: {color: '#909399'}
          },
          axisTick: {
            show: false
          }
        },
        series: [{
          type: 'bar',
          name: 'xxx',
          barWidth: '10',
          // barWidth: '60%',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(
              0, 0, 0, 1,
              [
                {offset: 0, color: '#3ECDEE'},
                {offset: 1, color: '#208EFF'}
              ]
            )
          },
          emphasis: {
            label: {
              show: true,
              position: 'top'
            },
            showBackground: true
          },
          data: []
        }]
      }
    }
  },
  methods: {
    changeEchart () {
      this.echart.setOption({
        xAxis: {
          axisLabel: this.value.axisLabel,
          data: this.value.xAxis
        },
        series: [{
          data: this.value.series
        }],
        yAxis: {
          name: this.value.name
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
    .content {
        position: relative;
    }

    .echart {
        width: 100%;
        height: 100%;
    }

    .title {
        position: absolute;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 12px;
        color: #aaa;
    }


    .title {
        top: 10px;
        color: #303133;
    }
</style>
